import React from 'react'

export const Markup: React.FC<{ htmlString: string }> = ({ htmlString }) => (
  // eslint-disable-next-line react/no-danger
  <div dangerouslySetInnerHTML={{ __html: htmlString }} />
)
